<template>
  <div class="row" v-if="canSearch">
    <div class="advanced-search width-100" style="margin-bottom: 10px">
      <form class="form-horizontal">
        <collapse v-model="activeNames">
          <collapse-item name="projects-search" class="col-md-12 card" style="padding-top: 10px; border: none;">
            <template slot="title">
              <div style="width: 100%; margin-right: 10px;">
                <h4 class="card-title title-black" style="display: inline; vertical-align: middle;">
                  Projects Search
                </h4>
                <button v-if="canAdd" type="button" @click.stop="createProjectAndJob" class="btn btn-fill btn-info pull-right" style="font-size: 12px">
                  Quick Add Project + Job
                </button>
                <button v-if="canAdd" type="button" @click.stop="createProject" class="btn btn-fill btn-info pull-right" style="font-size: 12px">
                  Add Project
                </button>
              </div>
            </template>
            <div class="form-group" style="margin-top: 10px">
              <div class="row">
                <div class="col-md-8">
                  <label style="font-size: 14px">Search any field or Project Name</label>
                  <el-input type="search"
                            name="querySearch"
                            placeholder="Search"
                            @keyup.enter.native="searchSubmit"
                            v-model="query.search"
                            clearable
                            v-validate="'minFields'"
                            data-vv-name="search"/>
                  <small class="text-danger" v-show="errors.has('search')">
                    {{ mainSearchFieldErrorText }}
                  </small>
                </div>
                <div class="col-md-2">
                  <label>Type
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-select class="select"
                             size="large"
                             placeholder="Type"
                             clearable
                             v-validate="'minFields'"
                             data-vv-name="search"
                             v-model="query.projectType">
                    <el-option v-for="option in projectTypes"
                               class="select"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-1">
                  <label>Active</label>
                  <p-switch v-model="query.active" type="primary" on-text="YES" off-text="NO" style="display:block"></p-switch>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-2">
                  <label>City
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-autocomplete
                    style="width:100%"
                    class="inline-input"
                    v-model="localCity"
                    @keyup.enter.native="searchSubmit"
                    clearable
                    :fetch-suggestions="findCities"
                    :trigger-on-focus="false"
                    ref="city"
                    name="city"
                    value-key="name"
                    placeholder="City"
                    @blur="verifyCityAutocompleteSelected"
                    v-validate="'minFields'"
                    data-vv-name="search"
                    @select="setCity">
                  </el-autocomplete>
                  <small class="text-danger" v-show="showInvalidAutocompleteWarning('city')">
                    {{ fieldNotValidError('City') }}
                  </small>
                </div>
                <div class="col-md-2">
                  <label>Street Number
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.streetNumber"
                            @keyup.enter.native="searchSubmit"
                            clearable
                            placeholder="Street Number"
                            v-validate="'minFields'"
                            data-vv-name="search"/>
                </div>
                <div class="col-md-2">
                  <label>Street Name
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-autocomplete
                    style="width:100%"
                    name="streetName"
                    ref="streetName"
                    class="inline-input"
                    v-model="localStreetName"
                    @keyup.enter.native="searchSubmit"
                    clearable
                    :fetch-suggestions="findStreets"
                    :trigger-on-focus="false"
                    value-key="name"
                    placeholder="Street Name"
                    @blur="verifyStreetNameAutocompleteSelected"
                    v-validate="'minFields'"
                    data-vv-name="search"
                    @select="setStreet">
                  </el-autocomplete>
                  <small class="text-danger" v-show="showInvalidAutocompleteWarning('streetName')">
                    {{ fieldNotValidError('Street Name') }}
                  </small>
                </div>
                <div class="col-md-2">
                  <label>County
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.county"
                            placeholder="County"
                            @keyup.enter.native="searchSubmit"
                            v-validate="'minFields'"
                            data-vv-name="search"
                            clearable/>
                </div>
                <div class="col-md-2">
                  <label>State</label>
                  <el-select class="select"
                             name="state"
                             size="large"
                             clearable
                             placeholder="State"
                             v-model="query.state">
                    <el-option v-for="option in states"
                               class="select"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-2">
                  <label>Building Number
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.buildingNumber"
                            placeholder="Building Number"
                            @keyup.enter.native="searchSubmit"
                            v-validate="'minFields'"
                            data-vv-name="search"
                            clearable/>
                </div>
                <div class="col-md-2">
                  <label>Floor Number
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.floorNumber"
                            placeholder="Floor Number"
                            @keyup.enter.native="searchSubmit"
                            v-validate="'minFields'"
                            data-vv-name="search"
                            clearable/>
                </div>
                <div class="col-md-2">
                  <label>Suite Number
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.suiteNumber"
                            @keyup.enter.native="searchSubmit"
                            clearable
                            placeholder="Suite Number"
                            v-validate="'minFields'"
                            data-vv-name="search"/>
                </div>
                <div class="col-md-2">
                  <label>Zip
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input class="select"
                            name="zip"
                            maxlength="5"
                            size="large"
                            placeholder="Zip"
                            @keyup.enter.native="searchSubmit"
                            v-validate="'minFields'"
                            data-vv-name="search"
                            v-model="query.zip"
                            clearable/>
                </div>
                <div class="col-md-2">
                  <label>Jurisdiction
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-select class="select"
                             name="jurisdiction"
                             size="large"
                             clearable
                             @keyup.enter.native="searchSubmit"
                             placeholder="Jurisdiction"
                             v-model="query.jurisdiction"
                             v-validate="'minFields'"
                             data-vv-name="search">
                    <el-option v-for="option in constants.JURISDICTIONS"
                               class="select"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-2">
                  <label>Lot Number
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.lotNumber"
                            @keyup.enter.native="searchSubmit"
                            clearable
                            placeholder="Lot Number"
                            v-validate="'minFields'"
                            data-vv-name="search"/>
                </div>
                <div class="col-md-2">
                  <label>Block Number
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.blockNumber"
                            @keyup.enter.native="searchSubmit"
                            placeholder="Block Number"
                            v-validate="'minFields'"
                            data-vv-name="search"
                            clearable/>
                </div>
                <div class="col-md-2">
                  <label>Section
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.section"
                            @keyup.enter.native="searchSubmit"
                            placeholder="Section"
                            clearable
                            v-validate="'minFields'"
                            data-vv-name="search"/>
                </div>
                <div class="col-md-2">
                  <label>Phase
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.phase"
                            @keyup.enter.native="searchSubmit"
                            clearable
                            placeholder="Phase"
                            v-validate="'minFields'"
                            data-vv-name="search"/>
                </div>
                <div class="col-md-4">
                  <label>Legal Subdivision
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-autocomplete
                    style="width:100%"
                    name="legalSubdivision"
                    ref="legalSubdivisionId"
                    class="inline-input"
                    clearable
                    :debounce="150"
                    v-model="localLegalSubdivision"
                    v-validate="'minFields'"
                    data-vv-name="search"
                    :fetch-suggestions="findLegalSubdivisions"
                    :trigger-on-focus="false"
                    value-key="name"
                    placeholder="Legal Subdivision"
                    @blur="verifyLegalSubdivisionAutocompleteSelected"
                    @select="setLegalSubdivision">
                  </el-autocomplete>
                  <small class="text-danger" v-show="showInvalidAutocompleteWarning('legalSubdivisionId')">
                    {{ fieldNotValidError('Legal Subdivision') }}
                  </small>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <label>Legal Description
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.legalDescription"
                            @keyup.enter.native="searchSubmit"
                            clearable
                            placeholder="Legal Description"
                            v-validate="'minFields'"
                            data-vv-name="search"/>
                </div>
                <div class="col-md-4">
                  <label>Metadata
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-input type="search"
                            v-model="query.metadata"
                            @keyup.enter.native="searchSubmit"
                            clearable
                            placeholder="Metadata"
                            v-validate="'minFields'"
                            data-vv-name="search"/>
                </div>
                <div class="col-md-4">
                  <label>Date Created
                    <span class="text-danger in-line-block" v-show="errors.has('search')">
                      {{ otherSearchFieldErrorText }}
                    </span>
                  </label>
                  <el-date-picker
                    v-model="query.createdBetween"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="-"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    :format="constants.DATE.FORMAT.DISPLAY"
                    :value-format="constants.DATE.FORMAT.VALUE"
                    :picker-options="datePickerConfig.dateRange"
                    v-validate="'minFields'"
                    data-vv-name="search">
                  </el-date-picker>
                </div>
              </div>
            </div><!-- card content -->
            <div class="card-footer search-footer">
              <button type="button" class="btn btn-fill btn-info pull-right" @click="searchSubmit">
                Search
              </button>
              <button type="button" class="btn btn-fill btn-info btn-company-search btn-clear pull-right" @click="clearForm">
                Clear
              </button>
            </div>
          </collapse-item>
        </collapse>
      </form>
    </div>
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-12">
          <div class="pull-right" style="margin-bottom: 6px;">
            <a @click.prevent="printerFriendly" v-if="hasResults" href="#"><img src="static/img/icon-print.png" title="Print Projects" class="m-left-12"/></a>
            <a @click.prevent="downloadExcel" v-if="hasResults" href="#"><img src="static/img/icon-excel.jpg" title="Export Projects to Excel" class="m-left-12"/></a>
          </div>
        </div>
        <div class="col-sm-12">
          <div v-if="loading" style="margin-top: 50px; text-align: center;">
            <img src="static/img/loading.gif"/>
          </div>
          <el-table class="table-striped wrap-whole-words indexed-table-column-width"
                    v-else
                    :data="queriedData"
                    border
                    :max-height="tableHeight(400)"
                    style="width: 100%">
            <el-table-column
              :width="indexColumnWidth"
              align="center"
              label="#"
              type="index">
            </el-table-column>
            <el-table-column
              :min-width="200"
              sortable
              label="Project Name"
              :sort-method="(a, b) => callStringSort(a._source, b._source, 'name')">
              <template v-slot="props">
                <router-link :to="`/projects/${props.row._id}`">{{ props.row._source.name }}</router-link>
                <el-tooltip v-if="props.row._source.description" class="item" effect="dark" :content="viewDescriptionNoHtml(props.row._source.description)" placement="right-end">
                  <img class="icon-help m-left-4" src="static/img/icon-info.png" />
                </el-tooltip>
                <el-tooltip v-if="props.row._source.stopWork" class="item" effect="dark" content="Work has stopped on this project" placement="right-end">
                  <img class="icon-help m-left-4" src="static/img/icon-stop.png" alt="Work has stopped on this project"/>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="Type"
              min-width="130"
              sortable
              :sort-method="(a, b) => callStringSort(a._source, b._source, 'projectType')"
              prop="_source.projectType">
              <template v-slot="props">
                {{ props.row._source.projectType }}
              </template>
            </el-table-column>
            <el-table-column
              label="St. #"
              min-width="90"
              sortable
              :sort-method="(a, b) => callNumberInStringSort(a._source.address, b._source.address, 'streetNumber')"
              prop="_source.address.streetNumber">
              <template v-slot="props">
                {{ props.row._source.address.streetNumber }}
              </template>
            </el-table-column>
            <el-table-column
              label="Street"
              min-width="130"
              sortable
              :sort-method="(a, b) => callStringSort(a._source.address, b._source.address, 'streetName')"
              prop="_source.address.streetName">
              <template v-slot="props">
                {{ props.row._source.address.streetName }}
              </template>
            </el-table-column>
            <el-table-column
              label="Bldg. #"
              min-width="105"
              sortable
              :sort-method="(a, b) => callNumberInStringSort(a._source.address, b._source.address, 'buildingNumber')"
              prop="_source.address.buildingNumber">
              <template v-slot="props">
                {{ props.row._source.address.buildingNumber }}
              </template>
            </el-table-column>
            <el-table-column
              label="Flr. #"
              min-width="90"
              sortable
              :sort-method="(a, b) => callNumberInStringSort(a._source.address, b._source.address, 'floorNumber')"
              prop="_source.address.FloorNumber">
              <template v-slot="props">
                {{ props.row._source.address.floorNumber }}
              </template>
            </el-table-column>
            <el-table-column
              label="Suite #"
              min-width="100"
              sortable
              :sort-method="(a, b) => callNumberInStringSort(a._source.address, b._source.address, 'suiteNumber')"
              prop="_source.address.suiteNumber">
              <template v-slot="props">
                {{ props.row._source.address.suiteNumber }}
              </template>
            </el-table-column>
            <el-table-column
              label="Lot #"
              min-width="90"
              sortable
              :sort-method="(a, b) => callNumberInStringSort(a._source.address, b._source.address, 'lotNumber')"
              prop="_source.address.lotNumber">
              <template v-slot="props">
                {{ props.row._source.address.lotNumber }}
              </template>
            </el-table-column>
            <el-table-column
              label="Blk #"
              min-width="100"
              sortable
              :sort-method="(a, b) => callNumberInStringSort(a._source.address, b._source.address, 'blockNumber')"
              prop="_source.address.blockNumber">
              <template v-slot="props">
                {{ props.row._source.address.blockNumber }}
              </template>
            </el-table-column>
            <el-table-column
              label="City"
              min-width="130"
              sortable
              :sort-method="(a, b) => callStringSort(a._source.address, b._source.address, 'city')"
              prop="_source.address.city">
              <template v-slot="props">
                {{ props.row._source.address.city }}
              </template>
            </el-table-column>
            <el-table-column
              label="Date Created"
              min-width="165"
              sortable
              :sort-method="(a, b) => callDateSort(a._source, b._source, 'createdAt')"
              prop="_source.createdAt">
              <template v-slot="props">
                {{ props.row._source.createdAt | formatDate }}
              </template>
            </el-table-column>
            <el-table-column
              width="105"
              fixed="right"
              label="Actions">
              <template v-slot="props">
                <p-button type="success" size="sm" icon>
                  <i class="fa fa-edit" @click="handleEdit(props.row._id)" title="View/Edit Project"></i>
                </p-button>
                <p-button v-if="canDelete" type="danger" size="sm" icon @click="confirmDelete(props.row)" title="Delete Project">
                  <i class="fa fa-times"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <span class="category">Showing {{total}} entries</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PProgress from 'src/components/UIComponents/Progress.vue'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import PButton from 'src/components/UIComponents/Button.vue'
import Constants from 'src/utilities/constants'
import datePickerConfig from '@/components/UIComponents/DatePicker/datePickerConfig'
import {Collapse, CollapseItem} from 'element-ui'
import {
  autocompleteReady,
  autocompleteTextButNoValue,
  autocompleteTextButNoValueMessage,
  dateSort,
  getTableHeight,
  maxResultsWarning,
  notifyError,
  notifySuccess,
  numberInStringSort,
  printModal,
  setIndexColumnWidth,
  stringSort,
  stripHTML,
  verifyAutocompleteSelected
} from 'src/utilities/utils'
import {mapGetters} from 'vuex'
import {minFields} from 'src/utilities/validation'
import Permissions from 'src/utilities/permissions'
import {NO_CONTENT, OK} from 'http-status-codes'
import {sync} from 'vuex-pathify'

export default {
  components: {
    PProgress,
    PButton,
    PSwitch,
    Collapse,
    CollapseItem
  },
  computed: {
    query: sync('projects/search@query'),
    ...mapGetters({
      states: 'states',
      projectTypes: 'types/project',
      tableData: 'projects/search/results'
    }),
    indexColumnWidth() {
      return setIndexColumnWidth(this.tableData.length)
    },
    queriedData() {
      return this.tableData
    },
    total() {
      return this.tableData.length
    },
    hasResults() {
      return this.tableData.length > 0
    },
    canAdd() {
      return this.$can('create', Permissions.PROJECTS)
    },
    canEdit() {
      return this.$can('edit', Permissions.PROJECTS)
    },
    canDelete() {
      return this.$can('delete', Permissions.DELETE.PROJECTS)
    },
    canSearch() {
      return this.$can('read', Permissions.PROJECTS)
    }
  },
  data() {
    return {
      activeNames: ['projects-search'],
      toDelete: null,
      constants: Constants,
      datePickerConfig,
      localCity: null,
      localStreetName: null,
      localLegalSubdivision: null,
      mainSearchFieldErrorText: Constants.MESSAGES.AT_LEAST_ONE_FIELD_REQUIRED,
      otherSearchFieldErrorText: '*',
      loading: false
    }
  },
  methods: {
    showInvalidAutocompleteWarning(refAndPathName) {
      // $ref has to match prop in store
      return autocompleteTextButNoValue(this, refAndPathName, this.$store.get(`projects/search/query@${refAndPathName}`))
    },
    fieldNotValidError(field) {
      return autocompleteTextButNoValueMessage(field)
    },
    printerFriendly() {
      this.$eventHub.$emit('show-modal-1', 'Project Search Results', null, '90%')
      printModal('projectSearchResults')
    },
    downloadExcel() {
      this.$store.dispatch('projects/search/resultsToExcel')
    },
    clearForm() {
      this.$validator.reset()
      this.$validator.pause()
      this.$store.commit('projects/search/resetQuery')
      this.$store.commit('projects/search/resetResults')
      this.localLegalSubdivision = null
      this.$store.commit('address/cities', [])
      this.localCity = null
      this.localStreetName = null
      setTimeout(this.resumeValidation, 250)
    },
    resumeValidation() {
      this.$validator.resume()
    },
    async searchSubmit() {
      if (await this.$validator.validateAll()) {
        this.loading = true
        const response = await this.$store.dispatch('projects/search/fetchElasticsearchResults')
        this.loading = false
        if (response.hits.total.value === 0) {
          this.$eventHub.$emit('show-modal-2', 'No Project Results Found', Constants.CREATE_PROJECT.FROM_PROJECT_SEARCH, '600px')
        }
        if (response.hits.total.value > Constants.ELASTICSEARCH.MAX_SEARCH_RESULTS) {
          maxResultsWarning(this, Constants.ELASTICSEARCH.MAX_SEARCH_RESULTS)
        }
      }
    },
    resultsNoValidate() {
      this.$store.dispatch('projects/search/fetchElasticsearchResults')
    },
    handleEdit(projectId) {
      this.$router.push({path: `/projects/${projectId}`})
    },
    confirmDelete(projectResult) {
      this.toDelete = projectResult._id
      const payload = {
        message: 'Are you sure you want to delete <strong>' + projectResult._source.name + '</strong>? This will completely remove the project plus associated jobs, tasks, and comments',
        entity: projectResult._source,
        delete: this.delete,
        showButton: true
      }
      this.$eventHub.$emit('show-modal-1', 'Confirm Delete', payload, '600px')
    },
    callStringSort(a, b, prop) {
      return stringSort(a, b, prop)
    },
    callNumberInStringSort(a, b, prop) {
      return numberInStringSort(a, b, prop)
    },
    callDateSort(a, b, prop) {
      return dateSort(a, b, prop)
    },
    tableHeight(buffer) {
      return getTableHeight(buffer)
    },
    async delete() {
      const response = await this.$store.dispatch('delete', {
        id: this.toDelete,
        endpoint: Constants.ENTITY_ENDPOINTS.PROJECTS
      })
      if (NO_CONTENT === response.status) {
        notifySuccess(this, 'Project Deleted Successfully')
        this.$store.commit('projects/search/delete', this.toDelete)
      } else {
        notifyError(this, 'Error Deleting Project')
      }
    },
    createProject() {
      this.$eventHub.$emit('show-modal-1', 'Create Project', {
        showButtons: true,
        source: Constants.CREATE_PROJECT.FROM_PROJECT_SEARCH
      }, '85%')
    },
    createProjectAndJob() {
      this.$store.commit('jobs/resetCreate')
      this.$eventHub.$emit('show-modal-1', 'Create Project And Job Wizard', null, '95%')
    },
    async findCities(text, cb) {
      if (text) {
        this.$store.set('projects/search/query@city', null)
        await this.$store.dispatch('address/cityStartsWith', text)
      } else {
        this.$store.commit('address/cities', [])
      }

      cb(this.$store.getters['address/cities'])
    },
    setCity(city) {
      this.$store.set('projects/search/query@city', city.name)
      this.$validator.reset()
    },
    verifyCityAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'projects/search@query.city', 'city', this.localCity)
    },
    async findStreets(text, cb) {
      if (autocompleteReady(text, Constants.AUTOCOMPLETE.STREET_CHAR_LENGTH)) {
        this.$store.set('projects/search/query@streetName', null)
        const city = this.$store.get('projects/search/query@city')
        let response = null
        if (city) {
          response = await this.$store.dispatch('address/streetStartsWithAndCityEquals', {
            city: city,
            streetName: text
          })
        } else {
          response = await this.$store.dispatch('address/streetStartsWith', text)
        }

        if (OK === response.status && response.data.length > 0) {
          cb(response.data)
        }
      }
    },
    async findLegalSubdivisions(text, cb) {
      if (autocompleteReady(text)) {
        this.$store.set('projects/search/query@legalSubdivisionId', null)

        await this.$store.dispatch('legalSubdivisions/fetchByNameStartsWith', text)
        const legalSubdivisions = this.$store.getters['legalSubdivisions/autocompleteResults']

        if (legalSubdivisions && legalSubdivisions.length > 0) {
          cb(legalSubdivisions)
        }
      }
    },
    setStreet(street) {
      this.$store.set('projects/search/query@streetName', street.name)
      this.$validator.reset()
    },
    setLegalSubdivision(legalSubdivision) {
      this.$store.set('projects/search/query@legalSubdivisionId', legalSubdivision.id)
      this.$validator.reset()
    },
    verifyStreetNameAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'projects/search@query.streetName', 'street name', this.localStreetName)
    },
    verifyLegalSubdivisionAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'projects/search@query.legalSubdivisionId', 'legal subdivision', this.localLegalSubdivision)
    },
    viewDescriptionNoHtml(description) {
      if (description) {
        return stripHTML(description)
      }
      return null
    },
    handleEditProject(project) {
      this.$router.push({path: `/projects/${project.id}`})
    },
    async maybePopulateLocalAutocompletes() {
      const searchProject = this.$store.get('projects/search@query')

      this.localCity = searchProject.city || null
      this.localStreetName = searchProject.streetName || null
      if (searchProject.legalSubdivision) {
        const response = await this.$store.dispatch('fetchById', {
          endpoint: Constants.ENTITY_ENDPOINTS.LEGAL_SUBDIVISIONS,
          id: searchProject.legalSubdivision
        })

        if (OK === response.status) {
          this.localLegalSubdivision = response.data.name
        }
      }
    }
  },
  beforeMount() {
    minFields('projects')
  },
  mounted() {
    this.$eventHub.$on('projectCreated', this.handleEditProject)
    // reset previous project edit
    this.$store.cache.dispatch('types/fetchByEntityType', 'Project')
    this.$store.commit('address/cities', [])
    this.$store.commit('address/streets', [])

    this.maybePopulateLocalAutocompletes()
  },
  destroyed() {
    this.$eventHub.$off('projectCreated')
  },
  watch: {
    localCity: {
      handler: function (city) {
        if (!city) {
          this.$store.set('projects/search/query@city', null)
          this.$validator.reset()
        }
      }
    },
    localStreetName: {
      handler: function (streetName) {
        if (!streetName) {
          this.$store.set('projects/search/query@streetName', null)
          this.$validator.reset()
        }
      }
    },
    localLegalSubdivision: {
      handler: function (localLegalSubdivision) {
        if (!localLegalSubdivision) {
          this.$store.commit('legalSubdivisions/autocompleteResults', [])
          this.$store.set('projects/search/query@legalSubdivisionId', null)
        }
      }
    }
  }
}
</script>
<style scoped>
  .row label {
    display: block;
  }
  .advanced-search .row {
    margin-bottom: 10px;
  }
  .fix-search-container {
    clear: both;
    margin-bottom: 15px;
  }
  .card .card-footer .btn-clear {
    margin-right: 12px;
  }
  .btn-clear {
    margin-left: 12px;
  }
  .btn-white {
    background-color: white;
    border-radius: 35px;
  }
  .search-footer {
    height: 50px;
    font-size: 14px;
    padding-right: 5px;
    padding-top: 10px;
  }
  .title-black {
    line-height: 35px;
    font-size: 24px;
    color: #252422;
  }
</style>
